import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Figure } from 'react-bootstrap';
import { toast } from 'react-toastify';

import {
  Accordion,
  DataMapper,
  LoaderWrapper,
  Wrapper
} from '@componentsApp/common';
import { useLocalStorage } from '@hooksApp/index';
import { tnl } from '@i18nApp/i18n';
import { getModuleQuestions } from '@pagesApp/Private/WorkUnit/Surveys/SurveysRequests';
import { surveyModulePreviewData } from './SurveyModulesData';
import { getPreviousAnswers } from './SurveyModulesRequests';
import SurveyQuestions from './SurveyQuestions/SurveyQuestions';

const SurveyModules = ({
  data,
  surveyPk,
  surveyForm,
  responseMapper,
  responseFormulaMapper,
  setResponseMapper,
  setResponseFormulaMapper,
  setFillingSurvey,
  historySelected,
  listView
}) => {
  const { userPermissions } = useLocalStorage();

  const [moduleQuestions, setModuleQuestions] = useState({
    isSearching: false,
    data: []
  });
  const [moduleSelected, setModuleSelected] = useState(null);
  const [preloadedFile, setPreloadedFile] = useState({});

  useEffect(() => {
    if (historySelected) {
      getPreviousAnswers({ surveyPk: historySelected.pk, setResponseMapper });
    } else if (surveyPk) {
      getPreviousAnswers({ surveyPk, setResponseMapper });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [historySelected]);

  return (
    <>
      {listView ? (
        <Accordion
          data={data}
          header={(module) => (
            <div className="w-100">
              <DataMapper
                data={surveyModulePreviewData(module)}
                columnsDesign="col-12 col-md-6"
              />
            </div>
          )}
          onEnter={async ({ pk }) => {
            if (moduleSelected === pk) return;

            const isValid = await surveyForm.trigger();

            if (!isValid) {
              toast.warning(tnl('toasts.invalid_answers'));
              return;
            }

            setModuleSelected(pk);
            getModuleQuestions({ module: pk, setModuleQuestions });
          }}
          body={({ pk }) => {
            return (
              <>
                {moduleSelected === pk && (
                  <LoaderWrapper
                    data={moduleQuestions.data}
                    isSearching={moduleQuestions.isSearching}
                  >
                    <SurveyQuestions
                      questionsData={moduleQuestions.data}
                      surveyForm={surveyForm}
                      responseMapper={responseMapper}
                      responseFormulaMapper={responseFormulaMapper}
                      setResponseMapper={setResponseMapper}
                      setResponseFormulaMapper={setResponseFormulaMapper}
                      setFillingSurvey={setFillingSurvey}
                      setPreloadedFile={setPreloadedFile}
                      preloadedFile={preloadedFile}
                      historySelected={historySelected}
                    />
                  </LoaderWrapper>
                )}
              </>
            );
          }}
        />
      ) : (
        <div>
          <div
            className="d-flex gap-2 py-3"
            style={{
              overflowX: 'auto',
              overflowY: 'hidden',
              scrollbarWidth: 'thin',
              scrollbarColor: '#ccc transparent'
            }}
          >
            {data.map((module) => (
              <div
                key={module.pk}
                onClick={async () => {
                  if (moduleSelected === module.pk) return;
                  const isValid = await surveyForm.trigger();
                  if (!isValid) {
                    toast.warning(tnl('toasts.invalid_answers'));
                    return;
                  }

                  setModuleSelected(module.pk);
                  getModuleQuestions({
                    module: module.pk,
                    setModuleQuestions
                  });
                }}
                style={{
                  backgroundColor:
                    moduleSelected === module.pk
                      ? 'var(--gray-light)'
                      : 'white',
                  minWidth: '250px',
                  flexShrink: 0
                }}
                className="d-flex flex-column align-items-center border p-3 rounded cursor-pointer"
              >
                <p className="fw-bold text-center">{module.name}</p>
                <Figure.Caption className="text-center">
                  {tnl('labels.count_of_questions', {
                    count: module.question_count
                  })}
                </Figure.Caption>
              </div>
            ))}
          </div>
          <div className="py-4">
            <Wrapper>
              <LoaderWrapper
                data={moduleQuestions.data}
                isSearching={moduleQuestions.isSearching}
              >
                <SurveyQuestions
                  questionsData={moduleQuestions.data}
                  surveyForm={surveyForm}
                  responseMapper={responseMapper}
                  responseFormulaMapper={responseFormulaMapper}
                  setResponseMapper={setResponseMapper}
                  setResponseFormulaMapper={setResponseFormulaMapper}
                  setFillingSurvey={setFillingSurvey}
                  setPreloadedFile={setPreloadedFile}
                  preloadedFile={preloadedFile}
                  historySelected={historySelected}
                />
              </LoaderWrapper>
            </Wrapper>
          </div>
        </div>
      )}
    </>
  );
};

SurveyModules.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  surveyPk: PropTypes.number,
  surveyForm: PropTypes.object.isRequired,
  responseMapper: PropTypes.object.isRequired,
  responseFormulaMapper: PropTypes.object.isRequired,
  setResponseMapper: PropTypes.func.isRequired,
  setResponseFormulaMapper: PropTypes.func.isRequired,
  setFillingSurvey: PropTypes.func,
  listView: PropTypes.bool
};

export default SurveyModules;
